import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";
import { DataResult } from "../../../types/Result";


interface Props extends PopupProps {
    functionalRoleId: number
}
interface EmployeeFunctionalRoleCreateModel {
    employeeId: number
    functionalRoleId: number
}

const AddEmployeeToFunctionalRolePopup: React.FC<Props> = ({ show, onHide, functionalRoleId }) => {
    const [serverErrors, setServerErrors] = useState<DataResult<EmployeeFunctionalRoleCreateModel>>({ isSuccesful: true, messages: [], data: undefined });
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<EmployeeFunctionalRoleCreateModel>({
        employeeId: 0,
        functionalRoleId: functionalRoleId,
    });

    const employees = useSelectListOptions('api/v1/selectlist/Employees?activeOnly=true', '-- Select employee');

    function submit() {
        if (formData) {
            DataService
                .create<EmployeeFunctionalRoleCreateModel>(`api/v1/EmployeeFunctionalRoles`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        if (onHide)
                            onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'employeeId', label: 'Employeee', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Add Employee'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('employeeId')} options={employees} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton text='Add' {...getSubmitButtonProps()} />
            </Popup.Footer>
        </Popup>
    );
}
export default AddEmployeeToFunctionalRolePopup;